import { render, staticRenderFns } from "./column-config-class.vue?vue&type=template&id=5ddb5f52&scoped=true&"
import script from "./column-config-class.vue?vue&type=script&lang=js&"
export * from "./column-config-class.vue?vue&type=script&lang=js&"
import style0 from "./column-config-class.vue?vue&type=style&index=0&id=5ddb5f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb5f52",
  null
  
)

export default component.exports